import React from 'react';
import { Header } from './components/Header';
import { ArticleContent } from './components/ArticleContent';
import { TrackingHead } from './components/TrackingHead';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <TrackingHead data-id="element-1" />
      <Header data-id="element-2" />
      <ArticleContent data-id="element-3" />
    </div>;
}